import React from "react";

interface VideoPlaybackFallbackProps {
  url: string;
  className?: string;
  style?: React.CSSProperties;
}

const baseStyle: React.CSSProperties = {
  minHeight: "350px",
  border: "none",
};

const VideoPlaybackFallback: React.FC<VideoPlaybackFallbackProps> = ({
  url,
  className = "w-100 h-100 rounded-4",
  style,
}) => (
  <div
    className={`${className} d-flex flex-column align-items-center justify-content-center bg-light`}
    style={{ ...baseStyle, ...style }}
  >
    <p className="text-muted mb-2 px-3 text-center">
      Unable to play this video here.
    </p>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-primary btn-sm"
    >
      Open video
    </a>
  </div>
);

export default VideoPlaybackFallback;
